import { System } from 'src/app/@framework/core/clms.fw.dotnet';
import * as Domain from '../Domain';
import * as Common from '../../@framework/common';
import { CLMS  } from 'src/app/@framework/core/clms.fw.common';
import { Joove } from 'src/app/@framework/core/Joove';
import * as moment from 'moment';
import { TranslateService } from '@ngx-translate/core';
import { DataListColumnInfo, DataListColumnItemType, ListDynamicColumnValue } from '@framework/components/DataList/helpers/List.helper.classes';
import { ValueFormat } from '@framework/core/clms.fw.angular';
var numeral = require('numeral');
const VerEx = require('verbal-expressions');


export class ExpensesClassificationCategoryValueObject  {
    _originalTypeClassName = "zERP.BO.ExpensesClassificationCategoryValueObject";
constructor(protected translateService: TranslateService = null) {
if (translateService != null) {
ExpensesClassificationCategoryValueObject.translate = translateService;
}
this.Types = [];
this.Id = null;
this.Name = null;
this.Description = null;
this.Code = null;
this.CodeStr = null;
this.FullName = null;
this._key = this.Id = 0; 
}

static translate: TranslateService;
_key: any;
private _Id:any;
get Id(): any {
    return this._Id;
  }
set Id(value: any) {
    this._Id = value;
    this._key = value;
  }
Name:any;
Description:any;
Code:any;
CodeStr:any;
FullName:any;
Types:any;
static setTypes = ($this, items) => {
                if (items == null) items = [];
                if ($this.Types == null) $this.Types = [];

                const copyItems = Common.cloneObject(items);

                while ($this.Types.length > 0) {
                    Domain.ExpensesClassificationCategoryValueObject.removeTypes($this, $this.Types[0]);
                }

                Domain.ExpensesClassificationCategoryValueObject.addManyTypes($this, copyItems);
            }
static addManyTypes = ($this, items) => {
                if (items == null) return;
                for (let i = 0; i < items.length; i++) {
                    Domain.ExpensesClassificationCategoryValueObject.addTypes($this, items[i]);
                }
            }
static addTypes = ($this, item) => {
                if ($this.Types == null) $this.Types = [];
                if (item == null || $this.Types.indexOf(item) > -1) return;
                $this.Types.push(item);
Domain.ExpensesClassificationTypeValueObject.addCategory(item, $this);
}
static addRangeTypes = ($this, items: System.Collections.List<any>) => { 
                items.forEach(item => Domain.ExpensesClassificationCategoryValueObject.addTypes($this, item));
            }
static removeTypes = ($this, item) => {
                if ($this == null || $this.Types == null || $this.Types.indexOf(item) === -1) return;
                var _index = $this.Types.indexOf(item);
                $this.Types.splice(_index, 1);
Domain.ExpensesClassificationTypeValueObject.removeCategory(item, $this);
}
static clearTypes = ($this) => { $this.Types = null; }

static CodeToDescription($this: any): any{switch ($this?.Code) {case Domain.ExpensesClassificationCategoryType.category2_1:
{
return "Αγορές Εμπορευμάτων";}
case Domain.ExpensesClassificationCategoryType.category2_2:
{
return "Αγορές Α'-Β' Υλών";}
case Domain.ExpensesClassificationCategoryType.category2_3:
{
return "Λήψη Υπηρεσιών";}
case Domain.ExpensesClassificationCategoryType.category2_4:
{
return "Γενικά Έξοδα με δικαίωμα έκπτωσης ΦΠΑ";}
case Domain.ExpensesClassificationCategoryType.category2_5:
{
return "Γενικά Έξοδα χωρίς δικαίωμα έκπτωσης ΦΠΑ";}
case Domain.ExpensesClassificationCategoryType.category2_6:
{
return "Αμοιβές και Παροχές προσωπικού";}
case Domain.ExpensesClassificationCategoryType.category2_7:
{
return "Αγορές Παγίων";}
case Domain.ExpensesClassificationCategoryType.category2_8:
{
return "Αποσβέσεις Παγίων";}
case Domain.ExpensesClassificationCategoryType.category2_9:
{
return "Έξοδα για λ/σμο τρίτων";}
case Domain.ExpensesClassificationCategoryType.category2_10:
{
return "Έξοδα προηγούμενων χρήσεων";}
case Domain.ExpensesClassificationCategoryType.category2_11:
{
return "Έξοδα επομένων χρήσεων";}
case Domain.ExpensesClassificationCategoryType.category2_12:
{
return "Λοιπές Εγγραφές Τακτοποίησης Εξόδων";}
case Domain.ExpensesClassificationCategoryType.category2_13:
{
return "Αποθέματα Έναρξης Περιόδου";}
case Domain.ExpensesClassificationCategoryType.category2_14:
{
return "Αποθέματα Λήξης Περιόδου";}
case Domain.ExpensesClassificationCategoryType.category2_95:
{
return "Λοιπά Πληροφοριακά Στοιχεία Εξόδων";}
default:
{
return "";}
}
}
static GetCodeStr($this: any): any{return $this?.Code + "";
}
static GetEnums(): any{let expensesClassificationCategoryTypes = [];
expensesClassificationCategoryTypes?.add(Domain.ExpensesClassificationCategoryType.category2_1);
expensesClassificationCategoryTypes?.add(Domain.ExpensesClassificationCategoryType.category2_2);
expensesClassificationCategoryTypes?.add(Domain.ExpensesClassificationCategoryType.category2_3);
expensesClassificationCategoryTypes?.add(Domain.ExpensesClassificationCategoryType.category2_4);
expensesClassificationCategoryTypes?.add(Domain.ExpensesClassificationCategoryType.category2_5);
expensesClassificationCategoryTypes?.add(Domain.ExpensesClassificationCategoryType.category2_6);
expensesClassificationCategoryTypes?.add(Domain.ExpensesClassificationCategoryType.category2_7);
expensesClassificationCategoryTypes?.add(Domain.ExpensesClassificationCategoryType.category2_8);
expensesClassificationCategoryTypes?.add(Domain.ExpensesClassificationCategoryType.category2_9);
expensesClassificationCategoryTypes?.add(Domain.ExpensesClassificationCategoryType.category2_10);
expensesClassificationCategoryTypes?.add(Domain.ExpensesClassificationCategoryType.category2_11);
expensesClassificationCategoryTypes?.add(Domain.ExpensesClassificationCategoryType.category2_12);
expensesClassificationCategoryTypes?.add(Domain.ExpensesClassificationCategoryType.category2_13);
expensesClassificationCategoryTypes?.add(Domain.ExpensesClassificationCategoryType.category2_14);
expensesClassificationCategoryTypes?.add(Domain.ExpensesClassificationCategoryType.category2_95);
return expensesClassificationCategoryTypes;
}
static GetFullName($this: any): any{return $this?.Code?.toString() + "-" + $this?.Name;
}

static IsNew($this: any): boolean {
                if ($this == null) return true;
                return $this.Id == null || $this.Id == 0;
            }


}